/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccDrecoV1AssetEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_DRECO_V1_ASSET_EVENT_ENTITY_NAME = 'ixc.dtcc.dreco.v1.AssetEvent';
export const ixcDtccDrecoV1AssetEventEntity = new schema.Entity<IxcDtccDrecoV1AssetEvent>(IXC_DTCC_DRECO_V1_ASSET_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcDtccDrecoV1AssetEvent) => `${entity.metadata?.eventId}` });

